export default {
    /**接口请求的基础路径 */
    baseUrl: {
      // dev: 'http://192.168.3.140:8085/joyplay-api',
      dev: 'https://www.mqty.top/joyplay-api',
      pro: 'https://www.mqty.top/joyplay-api' // 生产路径
    },
  };


